import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_7 = { class: "col-lg-4 col-md-4 mb-4" }
const _hoisted_8 = { class: "col-lg-4 col-md-4 mb-4" }
const _hoisted_9 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_10 = { class: "d-flex gap-1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "col-lg-4 col-md-4 mb-4" }
const _hoisted_13 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_14 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_15 = {
  key: 0,
  class: "col-lg-6 col-md-6 mb-4"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "col-lg-12 mb-4" }
const _hoisted_18 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Testimonial' : 'Add Testimonial',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Author Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                placeholder: "Enter name (e.g. John Doe)",
                required: "",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.autoInitials && _ctx.autoInitials(...args)))
              }, null, 544), [
                [_vModelText, _ctx.form.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Role / Affiliation", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.role) = $event)),
                placeholder: "Enter role (e.g. Student at UI)",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.role]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Initials", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.initials) = $event)),
                placeholder: "JD",
                max: "10",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.initials]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Avatar Color", -1)),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "color",
                  class: "form-control form-control-color",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.avatar_color) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.form.avatar_color]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presetColors, (color) => {
                    return (_openBlock(), _createElementBlock("button", {
                      type: "button",
                      key: color,
                      class: "btn p-0 border wh-20 rounded-circle",
                      style: _normalizeStyle({ backgroundColor: color }),
                      onClick: ($event: any) => (_ctx.form.avatar_color = color)
                    }, null, 12, _hoisted_11))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Rating (1-5 Stars)", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.rating) = $event)),
                required: ""
              }, _cache[14] || (_cache[14] = [
                _createStaticVNode("<option value=\"1\" data-v-6be7252f>1 Star</option><option value=\"2\" data-v-6be7252f>2 Stars</option><option value=\"3\" data-v-6be7252f>3 Stars</option><option value=\"4\" data-v-6be7252f>4 Stars</option><option value=\"5\" data-v-6be7252f>5 Stars</option>", 5)
              ]), 512), [
                [_vModelSelect, _ctx.form.rating]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Bootstrap Column Class", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.col_class) = $event))
              }, _cache[16] || (_cache[16] = [
                _createElementVNode("option", { value: "col-lg-4 col-md-12" }, "Three per row (col-lg-4 col-md-12)", -1),
                _createElementVNode("option", { value: "col-lg-6 col-md-12" }, "Two per row (col-lg-6 col-md-12)", -1),
                _createElementVNode("option", { value: "col-lg-12" }, "One per row (col-lg-12)", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.col_class]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Visibility Status", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.status) = $event))
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("option", { value: false }, "Hidden (Pending)", -1),
                _createElementVNode("option", { value: true }, "Published (Approved)", -1)
              ]), 512), [
                [_vModelSelect, _ctx.form.status]
              ])
            ]),
            (_ctx.form.order_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Linked Order ID", -1)),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    value: _ctx.form.order_id,
                    disabled: ""
                  }, null, 8, _hoisted_16)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Testimonial Text", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.text) = $event)),
                rows: "4",
                placeholder: "Enter testimonial content...",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.text]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_RouterLink, {
              to: "/testimonials",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update Testimonial' : 'Create Testimonial'), 1)
            ], 8, _hoisted_19)
          ])
        ], 32)
      ])
    ])
  ]))
}